import axios from "axios";


const instance = axios.create({});

// Declarando rota default
instance.defaults.baseURL = process.env.VUE_APP_URL;

// Interceptando requisição
instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("userToken");
  config.headers.common["Authorization"] = `Bearer ${token}`;
  return config;
});

// Interceptando resposta
instance.interceptors.response.use(
  (config) => config,
  (error) => {
    if (error.response.data.error == "Unauthenticated.") {
      alert("Você não está autenticado!");
      window.location.href = "/";
    }

    console.log(error.response);
    if (error.response.status >= 400) {
      if (typeof error.response.data.errors != "string") {
        Object.values(error.response.data.errors).map((value) => {
          throw value.toString();
        });
      } else {
        throw error.response.data.errors;
      }
    }
  }
);

export default instance;
